import { render, staticRenderFns } from "./received-documents.vue?vue&type=template&id=383333fc&scoped=true&"
import script from "./received-documents.vue?vue&type=script&lang=js&"
export * from "./received-documents.vue?vue&type=script&lang=js&"
import style0 from "./received-documents.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./received-documents.vue?vue&type=style&index=1&id=383333fc&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "383333fc",
  null
  
)

export default component.exports